// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".results[data-v-5a5bb2e3]{border-bottom:1px solid #dee2e5;padding-bottom:1rem}", "",{"version":3,"sources":["webpack://./resources/js/Pages/User/Edit.vue"],"names":[],"mappings":"AAAA,0BAAS,+BAAA,CAAgC,mBAGzC","sourcesContent":[".results{border-bottom:#dee2e5 solid 1px;padding-bottom:1rem}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
